/** External / deep links used by the app shell */

import {
  canUsePublicEoUrl,
  isLoopbackHost,
} from '../utils/apiConfig';

const canonicalizeKktUrl = (url) =>
  String(url || '').replace(/\.new\.kktbel\.ru/gi, '.kktbel.ru');

const PROD_EO = 'https://e-learn.kktbel.ru';
const LOCAL_EO = 'http://127.0.0.1:8082';

const trimSlash = (url) => String(url || '').trim().replace(/\/$/, '');

function siblingOrigin(toSub, fromSubs) {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length < 2) return '';
  const sub = (parts[0] || '').toLowerCase();
  const rest = parts.slice(1).join('.');
  if (!rest) return '';
  if (fromSubs.includes(sub)) {
    return `${protocol}//${toSub}.${rest}`;
  }
  return '';
}

function readRuntimeEoUrl() {
  try {
    return trimSlash(window.__KKT_CONFIG__?.EO_URL || '');
  } catch (_) {
    return '';
  }
}

export function resolveEoUrl() {
  const runtime = canonicalizeKktUrl(readRuntimeEoUrl());
  if (canUsePublicEoUrl(runtime)) return runtime;

  const env = canonicalizeKktUrl(trimSlash(process.env.REACT_APP_EO_URL || ''));
  if (canUsePublicEoUrl(env)) return env;

  if (typeof window === 'undefined') return PROD_EO;
  const { protocol, hostname } = window.location;
  if (isLoopbackHost(hostname)) return LOCAL_EO;
  const mappedElearn = siblingOrigin('e-learn', ['shedule', 'schedule']);
  if (mappedElearn) {
    const rest = hostname.split('.').slice(1).join('.');
    if (rest === 'kktbel.ru' || rest.endsWith('.kktbel.ru')) {
      return PROD_EO;
    }
    return canonicalizeKktUrl(mappedElearn);
  }
  const mappedEokkt = siblingOrigin('eokkt', ['shedule', 'schedule']);
  if (mappedEokkt) return canonicalizeKktUrl(mappedEokkt);
  const sub = (hostname.split('.')[0] || '').toLowerCase();
  if (sub === 'e-learn' || sub === 'eokkt') {
    return canonicalizeKktUrl(`${protocol}//${hostname}`.replace(/\/$/, ''));
  }
  const rest = hostname.split('.').slice(1).join('.');
  if (rest) {
    if (rest === 'kktbel.ru' || rest.endsWith('.kktbel.ru')) {
      return PROD_EO;
    }
    return canonicalizeKktUrl(`${protocol}//e-learn.${rest}`);
  }
  return PROD_EO;
}

export const LINKS = {
  vkCommunity: 'https://vk.com/public218711190',
  vkSupport: 'https://vk.ru/russkiy.ruslan',
  vkCommunityDm: 'https://vk.me/public218711190',
  telegramChannel: 'https://t.me/belkkt',
  telegramBot: 'https://t.me/belkkt_bot',
  /** Electronic learning (ЭО) — not Moodle */
  get eo() {
    return resolveEoUrl();
  },
  androidApk:
    process.env.REACT_APP_ANDROID_APK ||
    '/kkt-schedule.apk',
  payment:
    'https://online.vtb.ru/payments/universal?link=true&providerId=99dbc762-1ab0-4e44-91d2-6f6e202da711&groupId=Instituties',
  courses: 'https://courses.kktbel.ru',
};

export const PAYMENT_QR_SRC =
  'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' +
  encodeURIComponent(LINKS.payment);
